import React from 'react';
import GoogleLogo from '../../../assets/images/google-color.png';
import YelpLogo from '../../../assets/images/Yelp-Emblem.png';
import TripAdvisorLogo from '../../../assets/images/tripadvisor-icon.png';
import OpenTableLogo from '../../../assets/images/Opentable.png';

// Note: Translations (t function) cannot be used directly here as it's a hook.
// Data requiring translation needs to be structured such that keys can be passed to `t`
// within the components, or the data generation needs to happen within the component.

export const testimonialsData = [
  {
    // Using index or unique ID for translation key reference in the component
    key: 0,
    image: "/api/placeholder/64/64", // Replace with actual paths or imports if available
    // author: "Sarah Chen", // Fetch via t(`public.landing.testimonials.items.0.author`) in component
    // role: "Owner, The Golden Plate", // Fetch via t(...)
    // text: "FeedBacked transformed how we handle customer feedback...", // Fetch via t(...)
  },
  {
    key: 1,
    image: "/api/placeholder/64/64",
    // author: "Michael Rodriguez",
    // role: "Manager, Bistro 54",
    // text: "The AI-powered responses are incredibly personalized...",
  },
  {
    key: 2,
    image: "/api/placeholder/64/64",
    // author: "Emma Thompson",
    // role: "Director, Fine Dining Co",
    // text: "The analytics helped us identify and fix key issues...",
  },
];

// If trust logos are used, define them here
export const trustedByLogos = [
  '/logos/restaurant1.png', // Replace with actual paths or imports
  '/logos/restaurant2.png',
  '/logos/restaurant3.png',
  '/logos/restaurant4.png',
  '/logos/restaurant5.png',
];

// Integration Platform Logos
export const platformIntegrations = [
  {
    nameKey: 'public.landing.integration.platforms.google', // Key for t function
    logo: GoogleLogo,
    className: 'h-12'
  },
  {
    nameKey: 'public.landing.integration.platforms.yelp',
    logo: YelpLogo,
    className: 'h-16'
  },
  {
    nameKey: 'public.landing.integration.platforms.tripadvisor',
    logo: TripAdvisorLogo,
    className: 'h-14'
  },
  {
    nameKey: 'public.landing.integration.platforms.opentable',
    logo: OpenTableLogo,
    className: 'h-14'
  }
];

// Structure for Comparison Table Rows (keys used for translation)
export const comparisonRows = [
  "responseTime",
  "quality",
  "hours",
  "language",
  "sentiment",
  "cost"
];

// Structure for Stats Data (keys used for translation)
export const statsSectionData = [
  {
    valueKey: "public.landing.stats.satisfaction.value",
    labelKey: "public.landing.stats.satisfaction.label",
    sublabelKey: "public.landing.stats.satisfaction.sublabel",
  },
  {
    valueKey: "public.landing.stats.reviews.value",
    labelKey: "public.landing.stats.reviews.label",
    sublabelKey: "public.landing.stats.reviews.sublabel",
  },
  {
    valueKey: "public.landing.stats.timeSaved.value",
    labelKey: "public.landing.stats.timeSaved.label",
    sublabelKey: "public.landing.stats.timeSaved.sublabel",
  },
];

// Reusable Stat Card Component (if primarily used here)
// Or move to components/common if used more widely
export const StatCard = ({ value, label, sublabel }) => (
  <div className="transform hover:scale-105 transition-transform duration-300 ease-in-out">
    <div className="text-5xl font-bold mb-2">{value}</div>
    <div className="text-xl mb-1">{label}</div>
    <div className="text-blue-200 text-sm">{sublabel}</div>
  </div>
);


// Testimonial Results Stats (keys for translation)
export const testimonialResultsStats = [
    {
      valueKey: "public.landing.testimonials.results.stats.responseTime.value", // Example: You might need to adjust keys based on actual translation file
      labelKey: "public.landing.testimonials.results.stats.responseTime.label"
    },
    {
      valueKey: "public.landing.testimonials.results.stats.timeSaved.value",
      labelKey: "public.landing.testimonials.results.stats.timeSaved.label"
    },
    {
      valueKey: "public.landing.testimonials.results.stats.languages.value",
      labelKey: "public.landing.testimonials.results.stats.languages.label"
    },
    {
      valueKey: "public.landing.testimonials.results.stats.satisfaction.value",
      labelKey: "public.landing.testimonials.results.stats.satisfaction.label"
    }
];


// Final CTA Features (keys for translation)
export const finalCtaFeatures = [
    "public.landing.finalCta.features.trial",
    "public.landing.finalCta.features.noCard",
    "public.landing.finalCta.features.cancel"
];

// Dashboard Preview Content Keys (for translation)
export const dashboardPreviewKeys = {
  title: "public.landing.dashboard.preview.title",
  stats: {
    reviewsToday: {
      label: "public.landing.dashboard.preview.stats.reviewsToday.label",
      value: "public.landing.dashboard.preview.stats.reviewsToday.value",
      trend: "public.landing.dashboard.preview.stats.reviewsToday.trend"
    },
    responseRate: {
      label: "public.landing.dashboard.preview.stats.responseRate.label",
      value: "public.landing.dashboard.preview.stats.responseRate.value",
      trend: "public.landing.dashboard.preview.stats.responseRate.trend"
    },
    avgRating: {
      label: "public.landing.dashboard.preview.stats.avgRating.label",
      value: "public.landing.dashboard.preview.stats.avgRating.value",
      trend: "public.landing.dashboard.preview.stats.avgRating.trend"
    }
  },
  features: {
    analytics: "public.landing.dashboard.preview.features.analytics",
    response: "public.landing.dashboard.preview.features.response"
  }
};

// Hero Section Feature Keys (for translation)
export const heroFeatures = [
    { key: "public.landing.hero.features.trial" },
    { key: "public.landing.hero.features.noCard" },
    { key: "public.landing.hero.features.cancel" },
];

// Note: Feature Card data structure (with icons) is complex due to needing `t` for features list.
// It's better generated within the FeaturesSection component itself. 